import Default from './default/TripImportRules';

export default {
  functional: true,
  render(_h, { parent }) {
    return <Default />;
  },
};
